<ng-container *ngrxLet="sharedFacade.isLoaded$ as isLoaded">
  <div class="setPaddidngMainContainer">
    <div class="col-12">
      <label class="headerName">Project settings</label>
    </div>
    <div
      *ngIf="excelImported && allProjectDetails?.excelTemplateLink?.trim()"
      class="d-flex justify-content-between mt-4"
    >
      <div class="d-flex align-items-center">
        <span class="importTemplateText">Download the imported Excel file</span>
      </div>
      <div>
        <button
          style="width: auto !important"
          type="button"
          (click)="downloadExcel()"
          class="next-btn modelBtn"
        >
          Download &nbsp; <i class="bi bi-file-earmark-spreadsheet"></i>
        </button>
      </div>
    </div>
    <div class="col-12">
      <label class="subTitleName">Details</label>
    </div>

    <div>
      <ng-container>
        <form
          [formGroup]="allProjectForm"
          [ngClass]="{ 'disabled-popup': !showEdit }"
          (keydown.enter)="$event.preventDefault()"
        >
          <div class="row">
            <div class="col-sm-6 form-group" [ngClass]="{ 'disabled-project': isLockChecked }">
              <div class="project-spacing required" aria-required="true">
                <piqet-angular-common-input
                  formControlName="projectName"
                  [control]="allProjectForm.get('projectName')"
                  label="Project name"
                  placeholder="Project name"
                  [maxLength]="100"
                  [preventDot]="true"
                  [submitted]="submitted"
                  [disabled]="isLockChecked"
                  (customBlur)="onBlur($any(allProjectForm.get('projectName')?.value))"
                  [errorMessages]="{
                    dotError: 'project name can not contain a dot (.)'
                  }"
                >
                </piqet-angular-common-input>
              </div>
            </div>
            <div class="col-sm-6 form-group" [ngClass]="{ 'disabled-project': isLockChecked }">
              <div class="project-spacing required" aria-required="true">
                <piqet-angular-common-input
                  formControlName="projectNameForReport"
                  [control]="allProjectForm.get('projectNameForReport')"
                  label="Project name used in report"
                  placeholder="Project name used in report"
                  [maxLength]="300"
                  [preventDot]="true"
                  [submitted]="submitted"
                  [disabled]="isLockChecked"
                >
                </piqet-angular-common-input>
              </div>
            </div>

            <div class="col-sm-6">
              <piqet-angular-file-upload
                #fileUploadComponent
                [type]="'image'"
                [existingFileUrl]="projectSettingImage"
                [existingFileName]="selectedFiles"
                [isDisabled]="isLockChecked"
                [isImageValid]="isImageValid"
                [customConfig]="{ showPreview: false }"
                [customClass]="'col-sm-12'"
                (fileSelected)="onFileSelected($event)"
                (fileRemoved)="onFileRemoved()"
                (removeConfirmation)="deleteConfirmation()"
              >
              </piqet-angular-file-upload>

              <ng-template #showDisableProject>
                <ng-container *ngTemplateOutlet="canLockProject"></ng-container>
              </ng-template>
            </div>

            <ng-container
              *ngrxLet="projectFacade.defalutMaterialProjectList$ as defalutMaterialProjectList"
            >
              <div
                [ngClass]="{
                  'disabled-project': isLockChecked,
                  'pre-cross-img': selectedFiles,
                  'post-cross-img': !selectedFiles
                }"
                *ngIf="imageUrl || projectSettingImage; else showDisableProject"
                class="row"
              >
                <div class="row project-image-div">
                  <div
                    *ngIf="!selectedFiles || imageUrl || projectSettingImage"
                    class="cross-position"
                    (click)="deleteConfirmation(defalutMaterialProjectList)"
                  >
                    <img
                      src="./assets/icons/pop-up-cross.svg"
                      class="cross-icon"
                      width="15"
                      height="15"
                    />
                  </div>
                </div>
                <div class="row project-image-div">
                  <img [src]="imageUrl || projectSettingImage" width="120" height="120" />
                </div>
              </div>
            </ng-container>
          </div>

          <div class="row" *ngIf="imageUrl || projectSettingImage">
            <ng-container *ngTemplateOutlet="canLockProject"> </ng-container>
          </div>

          <div class="row status-mt" [ngClass]="{ 'disabled-project': isLockChecked }">
            <div class="col-sm-6">
              <div class="form-group required">
                <div class="project-spacing selctstops02">
                  <label *ngIf="allProjectForm.get('share')?.value" class="sub-header-drpdown pb-2"
                    >Share</label
                  >
                  <label
                    *ngIf="
                      !allProjectForm.get('share')?.value && allProjectForm.get('status')?.value
                    "
                    class="placeholder-sub-header pb-2"
                    >Holder_text</label
                  >
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #shareList
                    [items]="shareItems"
                    [searchable]="false"
                    bindLabel="name"
                    [searchFn]="commonInputSearch"
                    placeholder="Share with *"
                    formControlName="share"
                    (change)="selectTeam($event)"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control accordion-search search-input"
                          id="inputValidation"
                          placeholder="Search..."
                          (input)="shareList.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div
                  *ngIf="
                    (allProjectForm.controls['share']?.touched &&
                      allProjectForm.controls['share']?.invalid) ||
                    (submitted && !allProjectForm.controls['share'].value?.name)
                  "
                  class="input-error"
                >
                  Share is required
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group required">
                <label *ngIf="allProjectForm.get('status')?.value" class="sub-header-drpdown pb-2"
                  >Status</label
                >
                <label
                  *ngIf="allProjectForm.get('share')?.value && !allProjectForm.get('status')?.value"
                  class="placeholder-sub-header pb-2"
                  >Holder_text</label
                >
                <div class="project-spacing selctstops02">
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #status
                    [items]="statusList"
                    bindLabel="name"
                    [searchable]="false"
                    formControlName="status"
                    [searchFn]="commonInputSearch"
                    placeholder="Status"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control accordion-search search-input"
                          id="inputValidation"
                          placeholder="Search..."
                          (input)="status.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div
                  *ngIf="
                    (allProjectForm.controls['status']?.touched &&
                      allProjectForm.controls['status']?.invalid) ||
                    (submitted && !allProjectForm.controls['status'].value?.name)
                  "
                  class="input-error"
                >
                  Status is required
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="isShowTeamList" [ngClass]="{ 'disabled-project': isLockChecked }">
            <div class="col-sm-12">
              <div class="form-group required">
                <div class="project-spacing">
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #team
                    [items]="teamList"
                    bindLabel="name"
                    [searchable]="false"
                    formControlName="team"
                    [searchFn]="commonInputSearch"
                    placeholder="Select team *"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          placeholder="Search..."
                          type="text"
                          class="form-control search-input"
                          id="inputValidation"
                          (input)="team.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div
                  *ngIf="
                    (allProjectForm.controls['team']?.touched &&
                      allProjectForm.controls['team']?.invalid) ||
                    (submitted && isShowTeamList && !allProjectForm.controls['team'].value?.name)
                  "
                  class="input-error"
                >
                  Team is required
                </div>
              </div>
            </div>
          </div>

          <app-feature-lock
            [isDisabled]="isCheckSelectOrg"
            [featureCode]="FeatureCodes.PROJECT_ORG_PACKAGING_FOOTPRINT"
          >
            <div
              disabledStyle="blur"
              [piqetAngularSectionAccess]="FeatureCodes.PROJECT_ORG_PACKAGING_FOOTPRINT"
              class="row"
              [ngClass]="{
                'disabled-project': isLockChecked
              }"
            >
              <div
                class="col-12"
                [title]="'Org. categories'"
                text="Connect your organization's internal data with your PIQET projects here."
                [joyrideStep]="'step6'"
                [stepPosition]="'left'"
                (next)="onNext('step6')"
              >
                <label class="subTitleNameSKU header-text-crown-icon" id="org-internal-data">
                  Select Org. internal data categories
                  <app-crown-icon *ngIf="isCheckSelectOrg"></app-crown-icon>
                </label>
              </div>
              <div class="col-12 pb-3">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="text-icon-align">
                    <div>
                      <span class="sub-header-drpdown">Internal data</span>
                    </div>
                    <div>
                      <span
                        placement="auto"
                        tooltipClass="info-tooltip"
                        ngbTooltip="Organization internal data can now be integrated in your project reporting. This is not a requirement."
                      >
                        <a class="info-icon">
                          <span>
                            <img src="./assets/icons/grey-question-icon.svg" width="14" height="14"
                          /></span>
                        </a>
                      </span>
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-end align-items-center"
                    *ngIf="showInternalDataLink"
                  >
                    <a class="add-link" target="_blank" routerLink="/organization-report/upload-sku"
                      ><span class="redirectLinkText"> Add internal data</span></a
                    >
                    <a
                      class="setLinkIconPosition"
                      target="_blank"
                      replaceUrl="true"
                      routerLink="/organization-report/upload-sku"
                    >
                      <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
                    </a>
                    <span class="setLinkIconPosition" (click)="refreshSKU()"
                      ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
                    /></span>
                  </div>
                </div>
              </div>
            </div>
            <div
              disabledStyle="blur"
              [piqetAngularSectionAccess]="FeatureCodes.PROJECT_ORG_PACKAGING_FOOTPRINT"
              class="row"
              [ngClass]="{
                'disabled-project': isLockChecked
              }"
            >
              <div class="col-sm-4 abc">
                <div class="project-spacing selecttops">
                  <label
                    *ngIf="
                      allProjectForm.get('productDepartment')?.value ||
                      allProjectForm.get('productClass')?.value ||
                      allProjectForm.get('productFamily')?.value
                    "
                    class="sub-header-drpdown pb-2"
                    >Department</label
                  >
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    class="productSelect"
                    #prodDept
                    [items]="allDepartments"
                    [searchable]="false"
                    bindLabel="name"
                    [searchFn]="commonInputSearch"
                    placeholder="Department"
                    formControlName="productDepartment"
                    (change)="changeDept($event)"
                    (clear)="setDefaultData('department')"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control accordion-search search-input"
                          id="inputValidation"
                          placeholder="Search..."
                          (input)="prodDept.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
              <div class="col-sm-4 abc">
                <div class="project-spacing selecttops">
                  <label
                    *ngIf="
                      allProjectForm.get('productDepartment')?.value ||
                      allProjectForm.get('productClass')?.value ||
                      allProjectForm.get('productFamily')?.value
                    "
                    class="sub-header-drpdown pb-2"
                    >Category</label
                  >
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    class="productSelect"
                    #prodFamily
                    [items]="categoryListByDeptId"
                    [searchable]="false"
                    bindLabel="name"
                    [searchFn]="commonInputSearch"
                    placeholder="Category"
                    (change)="changeCatg($event)"
                    formControlName="productFamily"
                    (clear)="setDefaultData('category')"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control accordion-search search-input"
                          id="inputValidation"
                          placeholder="Search..."
                          (input)="prodFamily.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
              <div class="col-sm-4 abc">
                <div class="project-spacing selecttops">
                  <label
                    *ngIf="
                      allProjectForm.get('productDepartment')?.value ||
                      allProjectForm.get('productClass')?.value ||
                      allProjectForm.get('productFamily')?.value
                    "
                    class="sub-header-drpdown pb-2"
                    >Sub-category</label
                  >
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    class="productSelect"
                    #prodClass
                    [items]="subCategoryList"
                    [searchable]="false"
                    bindLabel="name"
                    [searchFn]="commonInputSearch"
                    placeholder="Sub-category"
                    formControlName="productClass"
                    (change)="changeSubCatg($event)"
                    (clear)="setDefaultData('subCategory')"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control accordion-search search-input"
                          id="inputValidation"
                          placeholder="Search..."
                          (input)="prodClass.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>
          </app-feature-lock>

          <div class="row" [ngClass]="{ 'disabled-project': isLockChecked }">
            <div class="col-sm-4">
              <div class="d-flex w-100 justify-content-between align-items-center checkboxview">
                <div class="d-flex checkBoxAlienMent">
                  <div>
                    <input
                      type="checkbox"
                      class="chkOverview"
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="isCostTurnedOff"
                      (change)="costTurnOff($event)"
                    />
                  </div>
                  <div><span class="checkbox-style text-nowrap">Switch on cost</span></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row"
            *ngIf="showCurrencyList"
            [ngClass]="{ 'disabled-project': isLockChecked }"
          >
            <div class="col-sm-12 currencyTab">
              <div class="project-spacing currency-drpdown">
                <ng-select
                  [clearable]="false"
                  [clearOnBackspace]="false"
                  #currency
                  [items]="currencyList"
                  (change)="selectCurrency($event)"
                  [searchable]="false"
                  bindLabel="name"
                  formControlName="currency"
                  [searchFn]="commonInputSearch"
                  placeholder="Currency"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="form-control accordion-search search-input"
                        id="inputValidation"
                        placeholder="Search..."
                        (input)="currency.filter($any($event.target).value)"
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>

          <hr />
          <div class="row" [ngClass]="{ 'disabled-project': isLockChecked }">
            <div class="col-12 input-div selectsprocesses">
              <div class="text-icon-align">
                <div>
                  <p class="processes-carried">Where will all of the processes be carried out?</p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="project-spacing selectsprocesses">
                <ng-select
                  [clearable]="false"
                  [ngClass]="
                    allProjectForm.controls['country'].value?.length > 10 ? 'multi-select' : ''
                  "
                  #country
                  [items]="regionItems"
                  [searchable]="false"
                  bindLabel="name"
                  bindValue="id"
                  [searchFn]="commonInputSearchForCountry"
                  [multiple]="true"
                  formControlName="country"
                  (change)="defalutCountry($event)"
                  placeholder="Select countries where all the processes will be carried out"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        class="search"
                        placeholder="Search..."
                        (input)="country.filter($any($event.target).value)"
                        type="text"
                        class="form-control search-input"
                        id="inputValidation"
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                      {{ item?.name }}
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                      {{ item?.description }}
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div>
              <p class="processes-carried">
                Highlight the default country where most process will be carried out *
              </p>
            </div>
            <div class="col-12">
              <div class="project-spacing selectDefaultCountry">
                <ng-select
                  [clearable]="false"
                  [clearOnBackspace]="false"
                  #defaultCountry
                  [items]="selectCountry || defaultRegionItems"
                  [searchable]="false"
                  bindLabel="name"
                  [searchFn]="commonInputSearchForCountry"
                  formControlName="defaultCountry"
                  placeholder="Select default country where most of the processes will be carried out *"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        class="search"
                        placeholder="Search..."
                        (input)="defaultCountry.filter($any($event.target).value)"
                        type="text"
                        class="form-control search-input"
                        id="inputValidation"
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                      {{ item?.name }}
                    </div>
                  </ng-template>
                </ng-select>
              </div>
              <div
                *ngIf="submitted && !allProjectForm.controls['defaultCountry'].value?.name"
                class="input-error"
              >
                Country is required
              </div>
            </div>
          </div>
          <hr class="custom-scope-hr" />
          <div class="row Projectscope" [ngClass]="{ 'disabled-project': isLockChecked }">
            <div class="col-12">
              <label
                [title]="'Project scopes'"
                text="Select from three project scope presets below or customise where required."
                [joyrideStep]="'step7'"
                [stepPosition]="'bottom'"
                class="subTitleName"
                id="proj-scope"
                (next)="onNext('step7')"
                >Project scope</label
              >
            </div>
            <div class="col-12">
              <p class="ScopePresents">Scope presets</p>
            </div>
          </div>
          <div class="row" [ngClass]="{ 'disabled-project': isLockChecked }">
            <ul class="nav nav-pills nav-justified buttonTab" id="myTab" role="tablist">
              <div class="col-4">
                <li class="nav-item" role="presentation">
                  <button
                    (click)="onClick('one', $event)"
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home"
                    type="button"
                    role="tab"
                    aria-controls="home"
                    aria-selected="true"
                  >
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="image">
                        <img [src]="one ? whitebox : blackbox" alt="" id="svgImage" />
                      </div>
                      <div class="title-settings">
                        <p title="Simple retail package ignoring product">
                          Simple retail package ignoring product
                        </p>
                      </div>
                    </div>
                  </button>
                </li>
              </div>
              <div class="col-4">
                <li class="nav-item" role="presentation">
                  <button
                    (click)="onClick('two', $event)"
                    id="profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home"
                    type="button"
                    role="tab"
                    aria-controls="profile"
                    aria-selected="false"
                  >
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="image">
                        <img [src]="two ? whiteRetail : blackRetail" alt="" id="svgImage" />
                      </div>
                      <div class="title-settings">
                        <p title="Retail, traded and pallet pkg. supply chain logistics">
                          Retail, traded and pallet pkg. supply chain logistics
                        </p>
                      </div>
                    </div>
                  </button>
                </li>
              </div>
              <div disabledStyle="blur" class="col-4 d-content">
                <li class="nav-item" role="presentation">
                  <app-feature-lock
                    [isDisabled]="isCheckFullLCA"
                    [featureCode]="FeatureCodes.PROJECT_FULL_PACKAGE_AND_PRODUCT_LCA"
                    [popupPosition]="'left'"
                  >
                    <button
                      [piqetAngularSectionAccess]="
                        FeatureCodes.PROJECT_FULL_PACKAGE_AND_PRODUCT_LCA
                      "
                      (click)="onClick('three', $event)"
                      id="contact-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#home"
                      type="button"
                      role="tab"
                      aria-controls="contact"
                      aria-selected="false"
                    >
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="image">
                          <img
                            [src]="three ? whiteFullPackage : blackFullPackage"
                            alt=""
                            id="svgImage"
                          />
                        </div>
                        <div class="title-settings">
                          <p
                            class="header-text-crown-icon"
                            id="fullLCAProduct"
                            title="Full package and product LCA"
                          >
                            Full package and product LCA
                            <app-crown-icon *ngIf="isCheckSelectOrg"></app-crown-icon>
                          </p>
                        </div>
                      </div>
                    </button>
                  </app-feature-lock>
                </li>
              </div>
            </ul>
          </div>

          <div class="row" [ngClass]="{ 'disabled-project': isLockChecked }">
            <div class="tab-content mt-3" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <div class="checkBoxGroup d-flex">
                  <div class="col-4">
                    <div class="text-icon-align">
                      <div>
                        <p class="my-2 h6">Packaging life cycle stages</p>
                      </div>
                      <div>
                        <span
                          placement="auto"
                          tooltipClass="sku-tooltip"
                          ngbTooltip="The various phases through which a packaging goes from extraction of raw materials to end-of-life."
                        >
                          <a class="info-icon">
                            <span>
                              <img
                                src="./assets/icons/grey-question-icon.svg"
                                width="14"
                                height="14" /></span
                          ></a>
                        </span>
                      </div>
                    </div>
                    <div
                      class="d-flex my-3 checkBoxAlienMent"
                      *ngFor="let item of packagingLCStages; let i = index"
                    >
                      <div>
                        <input
                          type="checkbox"
                          (change)="onChangeForCheckBox($event, item)"
                          id="{{ item.scopeId }}_{{ item.projectScopeTypeId }}"
                          class="chkOverview projectScopeChecks"
                        />
                      </div>
                      <div class="d-flex">
                        <span class="checkbox-style">{{ item.scopeName }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-4">
                    <div class="text-icon-align">
                      <div>
                        <p class="my-2 h6">Packaging levels</p>
                      </div>
                      <div>
                        <span
                          placement="auto"
                          tooltipClass="sku-tooltip"
                          ngbTooltip="The various tiers of packaging that can be used to contain and transport product
                                                                                                throughout the supply chain."
                        >
                          <a class="info-icon">
                            <span>
                              <img
                                src="./assets/icons/grey-question-icon.svg"
                                width="14"
                                height="14" /></span
                          ></a>
                        </span>
                      </div>
                    </div>
                    <div class="d-flex my-3 checkBoxAlienMent" *ngFor="let item of packagingLevels">
                      <div>
                        <input
                          type="checkbox"
                          (change)="onChangeForCheckBox($event, item)"
                          id="{{ item.scopeId }}_{{ item.projectScopeTypeId }}"
                          class="chkOverview projectScopeChecks"
                        />
                      </div>
                      <div class="d-flex">
                        <span class="checkbox-style">{{ item.scopeName }}</span>
                      </div>
                    </div>
                  </div>

                  <div disabledStyle="blur" class="col-4 col-sm-3">
                    <div class="text-icon-align">
                      <div>
                        <p class="my-2 h6">Sector-based product modelling</p>
                      </div>
                      <div>
                        <span
                          placement="auto"
                          tooltipClass="sku-tooltip"
                          ngbTooltip="Model product transport and product waste based on sector average."
                        >
                          <a class="info-icon">
                            <span
                              ><img
                                src="./assets/icons/grey-question-icon.svg"
                                width="14"
                                height="14" /></span
                          ></a>
                        </span>
                      </div>
                    </div>
                    <div class="my-3">
                      <div
                        class="d-flex my-3 checkBoxAlienMent"
                        *ngFor="let item of productWestModeling; let i = index"
                      >
                        <div>
                          <input
                            type="checkbox"
                            (change)="onChangeForCheckBox($event, item)"
                            id="{{ item.scopeId }}_{{ item.projectScopeTypeId }}"
                            class="chkOverview projectScopeChecks"
                          />
                        </div>
                        <div class="d-flex">
                          <span class="checkbox-style">{{ item.scopeName }}</span>
                        </div>
                      </div>
                      <div
                        class="d-flex my-3 checkBoxAlienMent"
                        *ngFor="let item of productLCStages?.slice(0, 1); let i = index"
                      >
                        <div>
                          <input
                            type="checkbox"
                            #lossBasedOnSector
                            name="item.scopeName"
                            (change)="onChangeForCheckBox($event, item)"
                            id="{{ item.scopeId }}_{{ item.projectScopeTypeId }}"
                            class="chkOverview projectScopeChecks"
                            [disabled]="one || disableSector"
                          />
                        </div>
                        <div class="d-flex">
                          <span class="checkbox-style">{{ item.scopeName }}</span>
                        </div>
                      </div>
                      <div class="my-3">
                        <div class="my-3" *ngIf="showSectorDropdown">
                          <div class="sector-drp">
                            <ng-select
                              [clearable]="true"
                              [clearOnBackspace]="false"
                              #sectorDrp
                              class="sectorNgSelect"
                              [items]="sectorList"
                              [searchable]="false"
                              bindLabel="description"
                              formControlName="sectorBasedDropdown"
                              [searchFn]=""
                              placeholder="Sector"
                              (change)="selectedSector($event)"
                              [virtualScroll]="true"
                            >
                              <ng-template ng-header-tmp>
                                <div class="has-feedback">
                                  <input
                                    placeholder="Search..."
                                    type="text"
                                    class="form-control accordion-search search-input"
                                    id="inputValidation"
                                    (input)="sectorDrp.filter($any($event.target).value)"
                                  />
                                  <span class="form-control-feedback">
                                    <i class="fa fa-search icon"></i>
                                  </span>
                                </div>
                              </ng-template>
                              <ng-template ng-label-tmp let-item="item">
                                <span class="ng-value-label" [attr.title]="item.description">{{
                                  item.description
                                }}</span>
                              </ng-template>
                              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                                  {{ item?.description }}
                                </div>
                              </ng-template>
                            </ng-select>
                            <div
                              *ngIf="
                                submitted &&
                                showSectorDropdown &&
                                !allProjectForm.controls['sectorBasedDropdown']?.value
                              "
                              class="input-error"
                            >
                              Product loss (based on sector average) is required.
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="text-icon-align"
                        [piqetAngularSectionAccess]="
                          FeatureCodes.PROJECT_FULL_PACKAGE_AND_PRODUCT_LCA
                        "
                      >
                        <div>
                          <p class="my-2 h6 header-text-crown-icon">Product project modelling</p>
                        </div>
                        <div>
                          <span
                            placement="auto"
                            tooltipClass="productToolTip"
                            ngbTooltip="Based on Product project created outside the Packaging project"
                          >
                            <a class="info-icon header-text-crown-icon">
                              <span>
                                <img
                                  src="./assets/icons/grey-question-icon.svg"
                                  width="14"
                                  height="14"
                              /></span>
                              <span class="crown-info-icon" *ngIf="isCheckSelectOrg"
                                ><app-crown-icon></app-crown-icon
                              ></span>
                            </a>
                          </span>
                        </div>
                      </div>

                      <app-feature-lock
                        [isDisabled]="isCheckFullLCA"
                        [featureCode]="FeatureCodes.PROJECT_FULL_PACKAGE_AND_PRODUCT_LCA"
                        [popupPosition]="'left'"
                      >
                        <div
                          class="d-flex my-3 checkBoxAlienMent"
                          *ngFor="let item of productLCStages?.slice(1, 3); let i = index"
                          [piqetAngularSectionAccess]="
                            FeatureCodes.PROJECT_FULL_PACKAGE_AND_PRODUCT_LCA
                          "
                        >
                          <div>
                            <input
                              type="checkbox"
                              (change)="onChangeForCheckBox($event, item)"
                              id="{{ item.scopeId }}_{{ item.projectScopeTypeId }}"
                              class="chkOverview projectScopeChecks"
                              [disabled]="one || two"
                              #lcsCheckboxes
                            />
                          </div>
                          <div class="d-flex">
                            <span class="checkbox-style">{{ item.scopeName }}</span>
                          </div>
                        </div>
                      </app-feature-lock>

                      <div class="text-icon-align">
                        <div>
                          <p class="my-2 h6">Other</p>
                        </div>
                        <div>
                          <span
                            placement="auto"
                            tooltipClass="sku-tooltip"
                            ngbTooltip="Other ways to account for product impact"
                          >
                            <a class="info-icon">
                              <span>
                                <img
                                  width="14"
                                  height="14"
                                  src="./assets/icons/grey-question-icon.svg" /></span
                            ></a>
                          </span>
                        </div>
                      </div>

                      <div
                        class="d-flex my-3 checkBoxAlienMent"
                        *ngFor="let item of fullProductLoss"
                      >
                        <div>
                          <input
                            type="checkbox"
                            (change)="onChangeForCheckBox($event, item)"
                            id="{{ item.scopeId }}_{{ item.projectScopeTypeId }}"
                            class="chkOverview projectScopeChecks"
                            [disabled]="one && item.scopeId == 5"
                          />
                        </div>
                        <div class="d-flex">
                          <span class="checkbox-style">{{ item.scopeName }}</span>
                        </div>
                      </div>

                      <div
                        class="d-flex my-3 checkBoxAlienMent"
                        *ngFor="let item of productLCStages?.slice(3); let i = index"
                      >
                        <div>
                          <input
                            type="checkbox"
                            (change)="onChangeForCheckBox($event, item)"
                            id="{{ item.scopeId }}_{{ item.projectScopeTypeId }}"
                            class="chkOverview projectScopeChecks"
                            [disabled]="(two && item.scopeId == 4) || three"
                          />
                        </div>
                        <div class="d-flex">
                          <span class="checkbox-style">{{ item.scopeName }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr class="hr" />
          <div class="row" [ngClass]="{ 'disabled-project': isLockChecked }">
            <div
              class="form-group"
              [joyrideStep]="'step12'"
              [stepPosition]="'bottom'"
              (prev)="onPrev('step12')"
              text="Previously labelled 'Project description'. Additional fields are for advanced reporting (e.g. ISO-14044 compliant report) and are not mandatory."
            >
              <label
                id="goalAndScope"
                *ngIf="allProjectForm.controls['description']?.value"
                class="sub-header-drpdown pb-2"
                >Goal and scope</label
              >
              <span
                *ngIf="allProjectForm.controls['description']?.value"
                class="ps-3 tooltip-header"
                placement="auto"
                tooltipClass="sku-tooltip"
                ngbTooltip="Specify the reason for the study."
              >
                <img src="./assets/icons/grey-question-icon.svg" width="16" height="16"
              /></span>
              <div class="services-form">
                <textarea
                  formControlName="description"
                  class="resizable-textarea"
                  cols="20"
                  id="Description"
                  name="Description"
                  rows="2"
                  placeholder="Goal and scope"
                ></textarea>
                <label *ngIf="!allProjectForm.controls['description']?.value">Goal and scope</label>
              </div>
            </div>

            <app-feature-lock
              [isDisabled]="isCheckAllTextarea"
              [featureCode]="FeatureCodes.PROJECT_SYSTEM_BOUNDARY_JUSTIFICATION"
              [popupPosition]="'top'"
            >
              <div
                [piqetAngularSectionAccess]="FeatureCodes.PROJECT_SYSTEM_BOUNDARY_JUSTIFICATION"
                class="form-group"
              >
                <label
                  *ngIf="allProjectForm.controls['boundryJustification']?.value"
                  class="sub-header-drpdown pb-2"
                  >System boundary justification</label
                >
                <span
                  *ngIf="allProjectForm.controls['boundryJustification']?.value"
                  class="ps-3 tooltip-header"
                  placement="auto"
                  tooltipClass="info-tooltip"
                  ngbTooltip="Provide rationale for your system boundary choices."
                >
                  <img src="./assets/icons/grey-question-icon.svg" width="16" height="16"
                /></span>
                <div class="services-form">
                  <textarea
                    formControlName="boundryJustification"
                    class="resizable-textarea"
                    cols="20"
                    id="Description"
                    name="Description"
                    rows="2"
                    placeholder="System boundary justification"
                  ></textarea>
                  <label *ngIf="!allProjectForm.controls['boundryJustification']?.value"
                    >System boundary justification</label
                  >
                </div>
              </div>

              <!-- Impact category justification -->
              <div
                disabledStyle="blur"
                [piqetAngularSectionAccess]="FeatureCodes.PROJECT_IMPACT_CATEGORY_JUSTIFICATION"
                class="form-group"
              >
                <label
                  *ngIf="allProjectForm.controls['categoryJustification']?.value"
                  class="sub-header-drpdown pb-2"
                  >Impact category justification</label
                >
                <span
                  *ngIf="allProjectForm.controls['categoryJustification']?.value"
                  class="ps-3 tooltip-header"
                  placement="auto"
                  tooltipClass="info-tooltip"
                  ngbTooltip="Explain how your set of indicators are consistent with the goal and scope."
                >
                  <img src="./assets/icons/grey-question-icon.svg" width="16" height="16"
                /></span>
                <div class="services-form">
                  <textarea
                    formControlName="categoryJustification"
                    class="resizable-textarea"
                    cols="20"
                    id="Description"
                    name="Description"
                    rows="2"
                    placeholder="Impact category justification"
                  ></textarea>
                  <label *ngIf="!allProjectForm.controls['categoryJustification']?.value"
                    >Impact category justification</label
                  >
                </div>
              </div>

              <!-- Other assumptions/limitations -->
              <div
                disabledStyle="blur"
                [piqetAngularSectionAccess]="FeatureCodes.PROJECT_OTHER_ASSUMPTIONS_LIMITATIONS"
                class="form-group"
              >
                <label
                  *ngIf="allProjectForm.controls['otherLimitations']?.value"
                  class="sub-header-drpdown pb-2"
                  >Other assumptions/limitations</label
                >
                <span
                  *ngIf="allProjectForm.controls['otherLimitations']?.value"
                  class="ps-3 tooltip-header"
                  placement="auto"
                  tooltipClass="info-tooltip"
                  ngbTooltip="List all value choices, assumptions or limitations that may affect any of the impact category results."
                >
                  <img src="./assets/icons/grey-question-icon.svg" width="16" height="16"
                /></span>
                <div class="services-form categoryJustification">
                  <textarea
                    formControlName="otherLimitations"
                    class="resizable-textarea"
                    cols="20"
                    id="Description"
                    name="Description"
                    rows="2"
                    placeholder="Other assumptions/limitations"
                  ></textarea>
                  <label *ngIf="!allProjectForm.controls['otherLimitations']?.value"
                    >Other assumptions/limitations</label
                  >
                </div>
              </div>
            </app-feature-lock>
            <ng-container
              *ngrxLet="projectFacade.defalutMaterialProjectList$ as defalutMaterialProjectList"
            >
              <div>
                <div class="form-group content">
                  <span
                    [joyrideStep]="'step13'"
                    [stepPosition]="'left'"
                    (next)="onNext('step13')"
                    text="Alter recycling credit allocation settings for individual materials or whole project."
                  >
                    <a class="link" (click)="showDeafultSettings()" class="defaultSettings">
                      Change default recycling credits settings</a
                    ></span
                  >
                  <span
                    class="pe-0"
                    placement="auto"
                    tooltipClass="sku-tooltip"
                    ngbTooltip="Adjust the A factor or select the PEF method that aims to reflect market realities."
                  >
                    <img src="./assets/icons/question-mark-icon.svg" width="14" height="14"
                  /></span>
                </div>
              </div>
              <div *ngIf="isShowDefalutSettings">
                <div class="row">
                  <div class="col-sm-6">
                    <label class="defaultSettingsData fw-bolder">Recycling credits</label>
                    <div class="form-group recycling-credit">
                      <div class="project-spacing recycling-drp-pos">
                        <ng-select
                          [clearable]="true"
                          [clearOnBackspace]="false"
                          #recyclingCred
                          [items]="allProjectDetails?.recycledCreditsList"
                          [searchable]="false"
                          bindLabel="name"
                          [searchFn]="commonInputSearch"
                          placeholder="Recycling credits"
                          formControlName="recycledCredit"
                          (change)="updateRange($event, defalutMaterialProjectList)"
                          (clear)="onClear(defalutMaterialProjectList)"
                        >
                          <ng-template ng-header-tmp>
                            <div class="has-feedback">
                              <input
                                type="text"
                                class="form-control accordion-search search-input"
                                id="inputValidation"
                                placeholder="Search..."
                                (input)="recyclingCred.filter($any($event.target).value)"
                              />
                              <span class="form-control-feedback">
                                <i class="fa fa-search icon"></i>
                              </span>
                            </div>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                            <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                              {{ item.name }}
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  [ngClass]="
                    allProjectForm.controls['recycledCredit'].value?.id !== 3 ? 'pb-4' : ''
                  "
                  *ngIf="allProjectForm.controls['recycledCredit'].value?.id == 3"
                >
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="defaultSettingsData">All credits for recycled content</label>
                      </div>
                    </div>

                    <div class="col-sm-6 text-end">
                      <div class="form-group">
                        <label class="defaultSettingsData"
                          >All credits for recycling at End-of-life</label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 form-group">
                      <div
                        aria-required="true"
                        [ngClass]="{ 'disabled-project': disableSlider ? true : false }"
                      >
                        <ngx-slider
                          [options]="options"
                          formControlName="recycleContent"
                          (userChangeEnd)="changeRuralValue($event)"
                        ></ngx-slider>
                      </div>
                    </div>
                    <div
                      class="col-sm-12 d-flex justify-content-end pe-3"
                      *ngIf="allProjectForm.controls['recycledCredit'].value?.id == 3"
                    >
                      <div class="form-group checkbox-text checkBoxAlienMent">
                        <input
                          class="chkOverview"
                          type="checkbox"
                          (change)="
                            applyToAllSlider(
                              defalutMaterialProjectList,
                              applyToAll,
                              allProjectForm.controls['recycledCredit'].value
                            )
                          "
                          [(ngModel)]="applyToAll"
                          [ngModelOptions]="{ standalone: true }"
                        />
                        <span class="defaultSettingsData"> Apply to all</span>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="errorMessage">
                    <div class="col-sm-12">
                      <p class="input-error">{{ errorMessage }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div>
                      <div class="input-error">{{ errorNotification }}</div>
                      <div id="divmanufactureofmaterialList" class="">
                        <input
                          data-val="true"
                          data-val-number="The field CustomMaterialId must be a number."
                          data-val-required="The CustomMaterialId field is required."
                          type="hidden"
                          value="0"
                        />
                        <piqet-angular-portlet
                          [columnDefs]="processColumnDef"
                          [frameworkComponents]="frameworkComponents"
                          [gridData]="defalutMaterialProjectList"
                          [hidePagination]="true"
                          [hideSearch]="true"
                          [isInlineGrid]="true"
                          [class]="'overflowCheck'"
                          (editDataEvent)="checkValidation(defalutMaterialProjectList)"
                          (inlineDataEditEvent)="inlineDataEditEvent($event)"
                          [recycleCreditId]="allProjectForm.controls['recycledCredit'].value?.id"
                          [error]="errorNotification"
                          [disableButton]="disableSubmit"
                          [sliderValue]="allProjectForm.controls['recycleContent'].value"
                          [headerBtn]="headerBtn"
                          [headerBtnName]="headerBtnName"
                        >
                        </piqet-angular-portlet>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </form>
        <div
          class="setButtonAndError text-margin"
          [ngClass]="{ 'disabled-project': isLockChecked }"
        >
          <div
            class="modal-footer justify-content-start"
            *ngrxLet="projectFacade.defalutMaterialProjectList$ as defalutMaterialProjectList"
          >
            <button
              type="button"
              *ngIf="showEdit"
              (click)="onSave(defalutMaterialProjectList)"
              [disabled]="disableSubmit"
              class="modelBtn purpleBtnHoverEffect"
            >
              Save
            </button>
            <button
              type="button"
              [ngStyle]="{ display: isLockChecked ? 'none' : 'inline-flex' }"
              (click)="nextPage(defalutMaterialProjectList)"
              [disabled]="disableSubmit"
              class="next-btn modelBtn"
            >
              Next <i class="bi bi-arrow-right checkbox-div"></i>
            </button>
          </div>

          <div
            class="redErrorTag"
            *ngIf="
              (submitted &&
                (allProjectForm.controls['projectName']?.invalid ||
                  allProjectForm.controls['projectNameForReport']?.invalid ||
                  allProjectForm.controls['status']?.invalid ||
                  allProjectForm.controls['share']?.invalid ||
                  allProjectForm.controls['defaultCountry']?.invalid ||
                  allProjectForm.controls['team']?.invalid ||
                  (showSectorDropdown &&
                    !allProjectForm.controls['sectorBasedDropdown']?.value))) ||
              allProjectForm.controls['projectName']?.hasError('dotError')
            "
          >
            <div class="bigScreenErrContain">
              <div>
                <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
              </div>
              <div>
                <div class="mb-3">
                  <span class="alert-error"
                    >To proceed please complete the following fields :
                  </span>
                </div>
                <div
                  class="topBottomCss"
                  *ngIf="
                    (submitted || allProjectForm.controls['projectName']?.touched) &&
                    allProjectForm.controls['projectName']?.invalid
                  "
                >
                  <div
                    class="alert-error"
                    *ngIf="
                      (allProjectForm.controls['projectName']?.touched &&
                        allProjectForm.controls['projectName']?.invalid) ||
                      allProjectForm.controls['projectName'].hasError('whitespace')
                    "
                  >
                    Project name
                  </div>
                </div>
                <div class="topBottomCss">
                  <div
                    class="alert-error"
                    *ngIf="allProjectForm.controls['projectName']?.hasError('dotError')"
                  >
                    The project name can not contain a dot (.)
                  </div>
                </div>
                <div
                  class="topBottomCss"
                  *ngIf="
                    (submitted || allProjectForm.controls['projectNameForReport']?.touched) &&
                    allProjectForm.controls['projectNameForReport']?.invalid
                  "
                >
                  <div
                    class="alert-error"
                    *ngIf="
                      (allProjectForm.controls['projectNameForReport']?.touched &&
                        allProjectForm.controls['projectNameForReport']?.invalid) ||
                      allProjectForm.controls['projectNameForReport'].hasError('whitespace')
                    "
                  >
                    Project name used in report
                  </div>
                </div>

                <div class="topBottomCss">
                  <div
                    class="alert-error"
                    *ngIf="
                      (allProjectForm.controls['share']?.touched &&
                        allProjectForm.controls['share']?.invalid) ||
                      ((submitted || allProjectForm.controls['share'].touched) &&
                        !allProjectForm.controls['share'].value?.name)
                    "
                  >
                    Share
                  </div>
                </div>
                <div class="topBottomCss">
                  <div
                    class="alert-error"
                    *ngIf="
                      (allProjectForm.controls['status']?.touched &&
                        allProjectForm.controls['status']?.invalid) ||
                      (submitted && !allProjectForm.controls['status'].value?.name)
                    "
                  >
                    Status is required
                  </div>
                </div>

                <div
                  class="topBottomCss"
                  *ngIf="isShowTeamList && !this.allProjectForm.controls['team'].value"
                >
                  <div
                    class="alert-error"
                    *ngIf="
                      (allProjectForm.controls['team']?.touched &&
                        allProjectForm.controls['team']?.invalid) ||
                      (submitted && !allProjectForm.controls['team'].value?.name)
                    "
                  >
                    Team
                  </div>
                </div>

                <div class="topBottomCss">
                  <div
                    *ngIf="submitted && !allProjectForm.controls['defaultCountry'].value?.name"
                    class="alert-error"
                  >
                    Country is required.
                  </div>
                </div>

                <div class="topBottomCss">
                  <div
                    *ngIf="
                      submitted &&
                      showSectorDropdown &&
                      !allProjectForm.controls['sectorBasedDropdown']?.value
                    "
                    class="alert-error"
                  >
                    Product loss (based on sector average) is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <ng-template #canLockProject>
      <div
        *ngIf="!hideProjectLock"
        class="col-sm-4"
        [ngClass]="imageUrl ? 'custom-align-disable-proj' : 'disable-proj-col'"
        style="pointer-events: visible"
      >
        <div class="d-flex w-100 align-items-center" [ngClass]="imageUrl ? '' : 'disableProj'">
          <div class="d-flex checkBoxAlienMent">
            <div>
              <input
                type="checkbox"
                class="chkOverview"
                [ngModelOptions]="{ standalone: true }"
                [ngClass]="{ 'disabled-popup': !showEdit }"
                [(ngModel)]="isLockChecked"
                (change)="lock($event)"
              />
            </div>
            <div class="d-flex">
              <span class="checkbox-style disable-edit">Disable editing capabilities</span>
            </div>
          </div>
          <div class="icon mb-2 mx-3">
            <img [src]="padlock" alt="" />
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>
